import clsx from 'clsx';
import React from 'react';
import './XOverlay.scss';
import { UiDialog, UiFlex, UiIconMaterial, UiText, UiImage } from '@open-stack/ui';
import logo from '../../../assets/orderx-logo.svg';

interface Props {
    type: 'loading' | 'success' | 'error';
    title?: any;
    description?: any;
}

export function XOverlay({ type, title, description }: Props) {
    return (
        <UiDialog isOpen setIsOpen={() => {}} className={clsx('_XOverlay')}>
            <UiFlex direction="column" gap={2} padding={4}>
                {type === 'loading' && (
                    <div>
                        <UiImage src={logo} className="loading" />

                        <div className="spinner-box">
                            <div className="configure-border-1">
                                <div className="configure-core" />
                            </div>

                            <div className="configure-border-2">
                                <div className="configure-core" />
                            </div>
                        </div>
                    </div>
                )}

                {type === 'success' && (
                    <>
                        <UiText color="success">
                            <UiIconMaterial>check_circle</UiIconMaterial>
                        </UiText>

                        {title && (
                            <UiText fontSize={4} weight={3} color="success">
                                {title}
                            </UiText>
                        )}

                        {description && (
                            <UiText fontSize={2} align={'center'}>
                                {description}
                            </UiText>
                        )}
                    </>
                )}

                {type === 'error' && (
                    <>
                        <UiText color="error">
                            <UiIconMaterial>cancel</UiIconMaterial>
                        </UiText>

                        {title && (
                            <UiText fontSize={4} weight={3} color="error">
                                {title}
                            </UiText>
                        )}

                        {description && <UiText fontSize={2}>{description}</UiText>}
                    </>
                )}
            </UiFlex>
        </UiDialog>
    );
}
